document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.clipboard').forEach(function (el) {
    el.addEventListener('click', function () {
      var value = el.dataset.clipboardText;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(function () {
          document.querySelectorAll('.clipboard_copied').forEach(function (msg) {
            msg.classList.add('is-visible');
          });
          setTimeout(function () {
            document.querySelectorAll('.clipboard_copied').forEach(function (msg) {
              msg.classList.remove('is-visible');
            });
          }, 1000);
        });
      }
    });
  });
});
